<template>
  <q-card
    flat
    class="q-pa-sm full-width no-padding-md"
    style="max-width: 100vw"
  >
    <q-card-section class="row q-pb-xs text-green-vito justify-between">
      <div class="text-h5">
        {{ $t("title.listStores") }} ({{ stores.length }})
      </div>
      <div class="q-gutter-x-md row">
        <div class="flex column justify-center">
          <q-btn
            v-if="isSuperAdmin"
            ref="addButton"
            color="primary"
            round
            dense
            icon="add"
            @click="showNew = true"
          >
            <q-tooltip class="bg-green-vito text-no-wrap">
              {{ $t("tooltip.addStore") }}
            </q-tooltip>
          </q-btn>
        </div>

        <q-input
          outlined
          dense
          clearable
          debounce="300"
          v-model="filterById"
          @update:model-value="setFilterById"
          :placeholder="$t('label.search')"
          style="width: 120px"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </div>
    </q-card-section>
    <q-card-section>
      <q-table
        :rows="stores"
        :columns="columnsI18n"
        row-key="id"
        v-model:pagination="pagination"
        :loading="loading"
        :filter="filter"
        class="sticky-header-table full-width"
      >
        <template v-slot:body-cell-isActive="props">
          <q-td :props="props">
            <q-icon
              size="sm"
              :color="props.value ? 'green-vito' : 'red-vito'"
              :name="props.value ? 'check_box' : 'disabled_by_default'"
            />
          </q-td>
        </template>
        <template v-slot:body-cell-actions="props">
          <q-td :props="props">
            <div>
              <q-btn
                icon="visibility"
                square
                round
                dense
                @click="displayStore(props.key)"
              >
                <q-tooltip class="bg-green-vito text-no-wrap">
                  {{ $t("tooltip.showOrder") }}
                </q-tooltip>
              </q-btn>
            </div>
          </q-td>
        </template>
      </q-table>
    </q-card-section>
  </q-card>
  <q-dialog v-model="showNew" ref="newStoreDialog">
    <store-card
      :storeId="0"
      action="create"            
      @cancel="cancel"
      @refresh="refresh"
      @displayOne="action = 'display'"
    />
  </q-dialog>

</template>
<script>
import StoreCard from "../components/store/StoreCard.vue";
import StoreApi from "../apis/Store";
import { useI18n } from "vue-i18n";

export default {
  name: "OrderPage",
  components: { StoreCard },
  setup() {
    const { locale } = useI18n({ useScope: "global" });
    return {
      locale,
    };
  },
  data: () => {
    return {
      refreshCounter: 0,
      action: "list",
      showNew: false,
      filter: "",
      filterById: "",
      loading: false,
      pagination: {
        rowsPerPage: 100,
      },
      store: {},
      stores: [],
    };
  },
  computed: {
    columnsI18n() {
      const columns = [
        {
          name: "id",
          required: true,
          label: "ID",
          align: "center",
          field: "id",
          sortable: true,
        },
        {
          name: "name",
          required: true,
          label: "Name",
          align: "center",
          field: "name",
          sortable: true,
        },
        {
          name: "location",
          required: true,
          label: "Location",
          align: "center",
          field: "location",
          sortable: true,
        },
        {
          name: "isActive",
          required: true,
          label: "Active",
          align: "center",
          field: "isActive",
          sortable: true,
        },
        { name: "actions", style: "width:70px" },
      ];
      return columns;
    },
    isSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
  mounted() {
    this.$store.state.title = "button.stores";
    this.getAllStores();
  },
  methods: {
    async cancel() {
      //console.log("cancel");
      await this.getAllStores();
      this.action = "list";
      this.showNew = false;
    },
    async refresh() {
      await this.getAllStores();
      this.action = "list";
      this.refreshCounter += 1;
      this.showNew = false;
    },
    async getAllStores() {
      try {
        const storesResponse = await StoreApi.findAll();
        this.stores = storesResponse.data;
      } catch (error) {
        const message = error.response
          ? error.response.data.message
          : error.message;
        this.errorMessage = message;
        this.$q.notify({
          type: "negative",
          message: message,
        });
      }
    },
    handleEdit(id) {
      this.store = this.stores.find((s) => s.id == id);
      this.action = "edit";
    },
    async handleDisplay(id) {
      await this.getAllStores();
      this.store = this.stores.find((s) => s.id == id);
      this.action = "display";
    },
    handleAddStore() {},
    displayStore(orderId) {
      this.$router.push("/store/" + orderId);
    },
    setFilterById(filter) {
      this.filter = filter;
    },

  },
};
</script>
